/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    confirmPassword?: string | null;
}

/**
 * Check if a given object implements the ResetPasswordDto interface.
 */
export function instanceOfResetPasswordDto(value: object): value is ResetPasswordDto {
    return true;
}

export function ResetPasswordDtoFromJSON(json: any): ResetPasswordDto {
    return ResetPasswordDtoFromJSONTyped(json, false);
}

export function ResetPasswordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'token': json['token'] == null ? undefined : json['token'],
        'password': json['password'] == null ? undefined : json['password'],
        'confirmPassword': json['confirmPassword'] == null ? undefined : json['confirmPassword'],
    };
}

export function ResetPasswordDtoToJSON(json: any): ResetPasswordDto {
    return ResetPasswordDtoToJSONTyped(json, false);
}

export function ResetPasswordDtoToJSONTyped(value?: ResetPasswordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'token': value['token'],
        'password': value['password'],
        'confirmPassword': value['confirmPassword'],
    };
}

